import { trpc } from "@/app/router";
import { ProductDetailModal } from "@/components/modals/product/product-detail-modal";
import { ProductEditModal } from "@/components/modals/product/product-edit-modal";


import { useQueryClient } from "@tanstack/react-query";
import {
  Outlet,
  createFileRoute,
  useNavigate,
  useSearch,
} from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { Loader2 } from "lucide-react";
import { Suspense, useEffect, useState } from "react";
import { Dialog, DialogContent } from "shadcn-ui";
import { z } from "zod";

// Initialize dayjs and TZ locale JP
dayjs.extend(utc);
dayjs.extend(timezone);

const searchSchema = z.object({
  productId: z.string().optional(),
  type: z.enum(["edit", "view"]).optional(),
  needRefresh: z.boolean().optional(),
});

export const Route = createFileRoute("/_app/inventory/product/_modal")({
  component: RouteComponent,
  validateSearch: zodValidator(searchSchema),
});

function RouteComponent() {
  const search = useSearch({
    from: "/_app/inventory/product/_modal",
  }) as {
    productId: string | undefined;
    type: "edit" | "view";
    needRefresh: boolean;
  };

  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const queryClient = useQueryClient();

  useEffect(() => {
    if (search.productId) {
      setOpen(true);
    } else {
      if (!open && search.productId) {
        queryClient.invalidateQueries(
          {
            refetchType: "none",
            queryKey: trpc.inventory.product.getById.queryOptions({
              productId: search.productId,
            }).queryKey,
          },
        );
        navigate({
          viewTransition: true,
          to: "/inventory/product",
        });
      }
      setOpen(open);
    }
  }, [search]);

  return (
    <div>
      <Outlet />
      {search.productId && (
        <Dialog
          open={open}
        // onOpenChange={(open) => {
        // 	if (!open && search.productId) {
        // 		queryClient.removeQueries(
        // 			trpc.inventory.product.getById.queryOptions({
        // 				productId: search.productId,
        // 			}),
        // 		);
        // 		navigate({
        // 			viewTransition: true,
        // 			to: "/inventory/product",
        // 		});
        // 	}
        // 	setOpen(open);
        // }}
        >
          <Suspense fallback={<Loader2 className="animate-spin" />}>
            {search.type === "edit" ? (
              <ProductEditModal />
            ) : (
              <ProductDetailModal />
            )}
          </Suspense>
        </Dialog>
      )}
    </div>
  );
}
